import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Skeleton from '@material-ui/lab/Skeleton';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import CustomScrollbars from '../../../../../util/CustomScrollbars';
import Insight from './components/insight'
import Swing from './components/swing'
import IntlMessages from "../../../../../util/IntlMessages";
import SessionListRender from './components/sessionList'
import NoDataAvailable from '../../components/NoDataAvailableRow'
import {
    getSessionList,
    getSessionData
} from '../../../../../actions/SessionAction';
import {
    getSwingList
} from '../../../../../actions/SwingAction';

class Session extends React.Component {
    constructor() {
        super()
        this.state = {
            drawerState: false,
            selectedSession: null,
            selectedSwing: 0
        }
        this.handleSessionMenuClick = this.handleSessionMenuClick.bind(this);
    }

    componentDidMount() {
        if (this.props.playerInView === null) {
            this.props.history.push('/app/players')
        } else {
            if (this.props.sessionList.length === 0 || this.props.playerInView.uid !== this.props.playerUid) {
                const sessionToken = this.props.authUser.sessionToken;
                const playerUid = this.props.playerInView.uid;
                const payload = {
                    'sessionToken': sessionToken,
                    'playerUid': playerUid
                }
                this.props.getSessionList(payload);
            } else {
                this.showSession()
            }
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.sessionListLoader === true && this.props.sessionListLoader === false && this.props.sessionListError === null) {
            this.showSession()
        }
        if (prevProps.sessionDataLoader === true && this.props.sessionDataLoader === false && this.props.sessionDataError === null && this.props.sessionData !== null) {
            const payload = {
                'sessionToken': this.props.authUser.sessionToken,
                'playerUid': this.props.playerInView.uid,
                'sessionId': this.state.selectedSession.sessionId
            }
            this.props.getSwingList(payload)
        }
    }

    showSession() {
        if (this.props.sessionList.length > 0) {
            this.setState({
                selectedSession: this.props.sessionList[0].sessions[0]
            })
            this.props.history.push('/app/user/session/' + this.props.sessionList[0].sessions[0].sessionId)
            this.loadSessionMenuSelector()

            if ((this.props.sessionDataLoader === false && this.props.sessionData === null) || (this.props.sessionData !== null && this.props.sessionData.hasOwnProperty('id') && this.props.sessionData.id !== this.props.sessionList[0].sessions[0].sessionId) || (this.props.sessionData !== null && this.props.sessionData.hasOwnProperty("uid") && this.props.playerInView.uid !== this.props.sessionData.uid)) {
                const sessionToken = this.props.authUser.sessionToken;
                const playerUid = this.props.playerInView.uid;
                const payload = {
                    'sessionToken': sessionToken,
                    'playerUid': playerUid,
                    'sessionId': this.props.sessionList[0].sessions[0].sessionId
                }
                this.props.getSessionData(payload)
            }
        }
    }


    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) {

        }

        return null;
    }
    handleSessionMenuClick(session) {
        // console.log("session : " + session)
        if (session != null) {
            this.setState({
                selectedSession: session,
                selectedSwing: 0
            })
            if (this.props.sessionData != null && this.props.sessionData.id !== session.sessionId) {
                const sessionToken = this.props.authUser.sessionToken;
                const playerUid = this.props.playerInView.uid;
                const payload = {
                    'sessionToken': sessionToken,
                    'playerUid': playerUid,
                    'sessionId': session.sessionId
                }
                this.props.getSessionData(payload)
            }
        }
    }

    SessionSideBar = () => {
        return (
            <div className="module-side" style={{ minWidth: '180px' }}>
                <div style={{ position: 'fixed', minWidth: '180px' }}>
                    {this.props.sessionListLoader || this.props.sessionListError !== null ? (
                        <Skeleton animation="wave" variant="rect" style={{ height: 700 }} />
                    ) : (
                            <div>
                                <div className="module-side-header">
                                    <div className="module-logo" style={{ minHeight: '50px' }}>
                                        <span><IntlMessages id="mySession.sessions" /></span>
                                    </div>

                                </div>

                                <div className="module-side-content">
                                    <CustomScrollbars className="module-side-scroll scrollbar"
                                        style={{ height: this.props.width >= 1200 ? 'calc(100vh - 240px)' : 'calc(100vh - 80px)' }}>
                                        <SessionListRender onHandleMenuClick={this.handleSessionMenuClick} sessionList={this.props.sessionList} history={this.props.history} />
                                    </CustomScrollbars >
                                </div>
                            </div>
                        )}
                </div>
            </div>
        )
    }

    loadSessionMenuSelector() {
        const { history } = this.props;
        const that = this;
        const pathname = `${history.location.pathname}`;// get current path

        const menuLi = document.getElementsByClassName('menu-session');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {
            // console.log("Error : " + error)
        }
    }
    onToggleDrawer() {
        if (this.state.drawerState !== true) {
            setTimeout(() => {
                this.loadSessionMenuSelector()
            }, 1000);
        }
        this.setState({
            drawerState: !this.state.drawerState
        });
    }
    handleChange = (event, selectSwing) => {
        this.setState({
            selectedSwing: selectSwing
        });
    };
    SwingSideBar = () => {
        return (
            <div className='swing-menu-container'>
                <div className='row'>
                    <div className='col-md-12 col-sm-12 col-xs-12'>
                        <div>
                            <AppBar position="static" color="default">
                                <Tabs
                                    value={this.state.selectedSwing}
                                    onChange={this.handleChange}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    indicatorColor="primary"
                                    textColor="primary"
                                >
                                    {this.state.selectedSession != null ? (this.state.selectedSession.sessionMode === "manual-video-recording" ? '' : <Tab label="Overall" />) : <Tab label="Overall" />}

                                    {[...Array(this.state.selectedSession.totalShots)].map((e, i) =>
                                        <Tab label={i + 1} key={i} />
                                    )}
                                </Tabs>
                            </AppBar>
                        </div>
                    </div>
                </div>
            </div >
        );
    };

    render() {
        return (
            <div className="app-wrapper">
                {!this.props.sessionListLoader && this.props.sessionList.length === 0 ? (
                    <NoDataAvailable />
                ) : (
                        <div className="app-module">
                            <div className="d-block d-xl-none">
                                <Drawer
                                    open={this.state.drawerState}
                                    onClose={this.onToggleDrawer.bind(this)}
                                    classes={{
                                        paper: 'side-nav',
                                    }}
                                >
                                    {this.SessionSideBar()}
                                </Drawer>
                            </div>
                            <div className="app-module-sidenav d-none d-xl-flex">
                                {this.SessionSideBar()}
                            </div>
                            <div className="swing-menu-box module-box">
                                <div className="module-box-header swing-menu-box-header">
                                    {this.props.sessionListLoader || this.props.sessionListError !== null ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 50 }} />
                                    ) : (
                                            <div>
                                                <div style={{ float: "left" }}>
                                                    <IconButton className="drawer-btn d-block d-xl-none" aria-label="Menu"
                                                        onClick={this.onToggleDrawer.bind(this)}>
                                                        <i className="zmdi zmdi-menu" />
                                                    </IconButton>
                                                </div>
                                                {this.state.selectedSession != null ? this.SwingSideBar() : ''}
                                            </div>
                                        )}
                                </div>
                                <div className="module-box-content">
                                    {this.state.selectedSwing === 0 ? (this.state.selectedSession != null ? (this.state.selectedSession.sessionMode !== "manual-video-recording" ? <Insight /> : <Swing swingNum={this.state.selectedSession.sessionMode !== "manual-video-recording" ? this.state.selectedSwing : this.state.selectedSwing + 1} selectedSession={this.state.selectedSession} />) : '') : <Swing swingNum={this.state.selectedSession.sessionMode !== "manual-video-recording" ? this.state.selectedSwing : this.state.selectedSwing + 1} selectedSession={this.state.selectedSession} />}
                                </div>
                            </div>
                        </div>
                    )}
            </div>

        );
    }
}

const mapStateToProps = ({ player, auth, session, swing }) => {
    const { authUser } = auth;
    const { playerInView } = player;
    const { playerUid, sessionList, sessionListLoader, sessionListError, sessionData, sessionDataLoader, sessionDataError } = session;
    const { swingList } = swing;
    return { authUser, playerInView, playerUid, sessionList, sessionListLoader, sessionListError, sessionData, sessionDataLoader, sessionDataError, swingList }
};
export default withRouter(connect(mapStateToProps, {
    getSessionList,
    getSessionData,
    getSwingList
})(Session));